import React, { useEffect, useState } from "react";
import "c3/c3.css";
import "./index.scss";
import Dropdown from "../../../components/core/dropdown";
import Tabs from "../../../components/core/tab";
import C3 from "../../../components/core/c3";
import Table from "../../../components/core/table";
import DateRangePicker from "../../../components/core/daterangepicker";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as _ from "lodash";
import * as Moment from "moment";
import { listStaff, readStaff } from "../../../store/staff/thunkAction";
import { reportChat, reportRating } from "../../../store/session/thunkAction";
import { getListProfile } from "../../../store/profile/thunkAction";
import { reportStaffOnline } from "../../../store/staff-stats/thunkAction";
import Tooltip from "../../../components/core/tooltip";
import Autocomplete from "../../../components/core/autocomplete";

const ReportManage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [startAt, setStartAt] = useState(
    Moment().subtract(6, "days").startOf("day").valueOf()
  );
  const [endAt, setEndAt] = useState(Moment().endOf("day").valueOf());
  const [agents, setAgents] = useState([]);
  const [domain, setDomain] = useState("");
  const [staffIds, setStaffIds] = useState([]);
  const [currentTab, setCurrentTab] = useState("report_chat");
  const [isResetDay, setIsResetDay] = useState({});

  const sessionManage = useSelector((state) => state.sessionManage);
  const tokenManage = useSelector((state) => state.tokenManage);
  const staffManage = useSelector((state) => state.staffManage);
  const profileManage = useSelector((state) => state.profileManage);
  const staffStatsManage = useSelector((state) => state.staffStatsManage);
  const [tooltipConfig, setTooltipConfig] = useState({
    visible: false,
    text: "",
    x: 0,
    y: 0,
  });

  const profiles = _.get(profileManage, "profiles");
  const staffs = _.get(staffManage, "staffs", {});
  const hasToken = _.get(tokenManage, "hasToken");
  const chatReport = _.get(sessionManage, "reportChat");
  const ratingReport = _.get(sessionManage, "reportRating");
  const staffReport = _.get(staffStatsManage, "reportStaffOnline");

  const dateChatReports = _.get(chatReport, "dateReports", []);

  const staffChatReports = _.orderBy(
    _.get(chatReport, "staffReports", []),
    [(item) => item.staffId === "null"],
    ["asc"]
  );

  const totalRating = _.get(ratingReport, "total", 0);
  const totalGood = _.get(ratingReport, "good", 0);
  const totalBad = _.get(ratingReport, "bad", 0);
  const totalUnrated = _.get(ratingReport, "unrated", 0);
  const averageGood = totalRating
    ? _.round((totalGood / (totalGood + totalBad)) * 100, 1)
    : 0;
  const dateRatingReports = _.get(ratingReport, "dateRatingReports", []);
  const staffRatingReports = _.orderBy(
    _.get(ratingReport, "staffRatingReports", []),
    [(item) => item.staffId === "null"],
    ["asc"]
  );

  const staffOnlineReports = _.get(staffReport, "staffOnlineReports", []);
  const dates = _.get(staffReport, "dates", []);

  const mapConfigDomain = {
    id: "domain",
    name: "domain",
  };

  const sortedReports = _.cloneDeep(dateChatReports).sort((a, b) => {
    return (
      Moment(a.date, "DD/MM/YYYY").toDate().getTime() -
      Moment(b.date, "DD/MM/YYYY").toDate().getTime()
    );
  });

  const sortedRatingReports = _.cloneDeep(dateRatingReports).sort((a, b) => {
    return (
      Moment(a.date, "DD/MM/YYYY").toDate().getTime() -
      Moment(b.date, "DD/MM/YYYY").toDate().getTime()
    );
  });

  const dateChats = sortedReports.map((item) => item.date);
  const hourChats = _.range(24).map(
    (hour) => `${_.padStart(hour.toString(), 2, "0")}:00`
  );

  const servedData = ["data1", ...sortedReports.map((item) => item.served)];
  const missedData = ["data2", ...sortedReports.map((item) => item.missed)];

  const dateRatings = sortedRatingReports.map((item) => item.date);
  const goodData = ["data1", ...sortedRatingReports.map((item) => item.good)];
  const badData = ["data2", ...sortedRatingReports.map((item) => item.bad)];
  const unratedData = [
    "data3",
    ...sortedRatingReports.map((item) => item.unrated),
  ];

  const maxDateChat = _.max(
    _.flatMap(staffChatReports, (item) =>
      item.dateReports.map((r) => Math.max(r.missed, r.served))
    )
  );

  const maxTotalChat = _.max(
    staffChatReports.map((item) => Math.max(item.missed, item.served))
  );

  const mapChatTable = staffChatReports.map((staff) => {
    const name =
      staffs[staff.staffId]?.name || t("settings.manage.report.no_agent");

    const dateData = _.reduce(
      staff.dateReports,
      (acc, item) => {
        acc[item.date] = {
          served: item.served,
          missed: item.missed,
        };
        return acc;
      },
      {}
    );

    return {
      name,
      ...dateData,
      total: {
        served: staff.served,
        missed: staff.missed,
      },
    };
  });

  const mapStaffTable = staffOnlineReports.map((staff) => {
    const name =
      staffs[staff.staffId]?.name || t("settings.manage.report.no_agent");
    const totalTimeOnline = _.get(staff, "totalTimeOnline", {});
    const hour = _.get(totalTimeOnline, "hour", 0);
    const minute = _.get(totalTimeOnline, "minute", 0);
    const second = _.get(totalTimeOnline, "second", 0);
    const total = `${hour} ${t("settings.manage.report.hour")} ${minute} ${t(
      "settings.manage.report.minute"
    )} ${second} ${t("settings.manage.report.second")}`;

    const dateData = _.reduce(
      staff.dateOnlineReports,
      (acc, item) => {
        acc[item.date] = {
          hourOnlineReports: item.hourOnlineReports,
        };
        return acc;
      },
      {}
    );

    const hourData = _.reduce(
      staff.hoursOnlineReports,
      (acc, item) => {
        acc[item.hour] = {
          minuteOnlineReports: item.minuteOnlineReports,
        };
        return acc;
      },
      {}
    );

    return {
      name,
      ...dateData,
      ...hourData,
      total,
    };
  });

  const mapRatingTable = staffRatingReports.map((staff) => {
    const name =
      staffs[staff.staffId]?.name || t("settings.manage.report.no_agent");
    const good = _.get(staff, "good", 0);
    const bad = _.get(staff, "bad", 0);
    const unrated = _.get(staff, "unrated", 0);
    const total = good + bad + unrated;

    const dateData = _.reduce(
      staff.dateRatingReports,
      (acc, item) => {
        acc[item.date] = {
          good: item.good,
          bad: item.bad,
        };
        return acc;
      },
      {}
    );

    return {
      name,
      ...dateData,
      good,
      bad,
      unrated,
      total,
    };
  });

  useEffect(() => {
    if (hasToken) {
      dispatch(listStaff());
      dispatch(readStaff());
      dispatch(getListProfile());
    }
  }, [dispatch, hasToken]);

  useEffect(() => {
    setAgents(_.values(staffs));
  }, [staffs]);

  useEffect(() => {
    const filter = {
      startAt,
      endAt,
      staffIds: _.map(staffIds, (staffIds) => staffIds._id),
      domain,
    };

    if (hasToken && currentTab === "report_chat") {
      dispatch(reportChat(filter));

      return;
    }

    if (hasToken && currentTab === "rating") {
      dispatch(reportRating(filter));

      return;
    }
  }, [dispatch, hasToken, staffIds, startAt, endAt, currentTab, domain]);

  useEffect(() => {
    const filter = {
      startAt,
      endAt,
      staffIds: _.map(staffIds, (staffIds) => staffIds._id),
    };

    if (hasToken && currentTab === "agent_online") {
      dispatch(reportStaffOnline(filter));

      return;
    }
  }, [dispatch, hasToken, staffIds, startAt, endAt, currentTab, isResetDay]);

  const onChangeDateRangePicker = (dateRanger) => {
    const start = _.get(dateRanger, "start");
    const end = _.get(dateRanger, "end");

    const startOfDay = Moment(start).startOf("day").valueOf();
    const endOfDay = Moment(end).endOf("day").valueOf();

    setStartAt(startOfDay);
    setEndAt(endOfDay);
    setIsResetDay({});
  };

  const chartChatConfig = {
    data: {
      columns: [servedData, missedData],
      type: "bar",
      names: {
        data1: t("settings.manage.report.chat_served"),
        data2: t("settings.manage.report.chat_missed"),
      },
    },
    axis: {
      x: {
        type: "category",
        categories: dateChats,
      },
    },
    grid: {
      y: {
        show: true,
      },
    },
    bar: {
      width: 12,
    },
    color: {
      pattern: ["#1CCBA1", "#F25858"],
    },
    legend: {
      position: "inset",
      inset: {
        anchor: "top-left",
        x: 0,
        y: -40,
        step: 1,
      },
    },
    padding: {
      top: 40,
    },
  };

  const chartRatingConfig = {
    data: {
      columns: [goodData, badData, unratedData],
      type: "bar",
      names: {
        data1: t("settings.manage.report.rated_good"),
        data2: t("settings.manage.report.rated_bad"),
        data3: t("settings.manage.report.unrated"),
      },
    },

    axis: {
      x: {
        type: "category",
        categories: dateRatings,
      },
    },
    grid: {
      y: {
        show: true,
      },
    },
    bar: {
      width: 12,
    },
    color: {
      pattern: ["#1CCBA1", "#F25858", "#BAC6D8"],
    },
    legend: {
      position: "inset",
      inset: {
        anchor: "top-left",
        x: 0,
        y: -40,
        step: 1,
      },
    },
    padding: {
      top: 40,
    },
  };

  const donutRatingConfig = {
    data: {
      columns: [
        ["data1", totalGood],
        ["data2", totalBad],
        ["data3", totalUnrated],
      ],
      type: "donut",
      names: {
        data1: t("settings.manage.report.rated_good"),
        data2: t("settings.manage.report.rated_bad"),
        data3: t("settings.manage.report.unrated"),
      },
    },
    tooltip: {
      format: {
        value: function (value) {
          return value;
        },
      },
    },
    donut: {
      title: `${totalRating} ${t("settings.manage.report.rating")}`,
      width: 40,
    },
    color: {
      pattern: ["#1CCBA1", "#F25858", "#BAC6D8"],
    },
  };

  const mapConfigAgent = {
    id: "_id",
    name: "name",
  };

  const configChatTable = {
    header: [
      {
        key: "agent",
        label: t("settings.manage.report.agent"),
        className: "text-center small",
        render: (row) => {
          const name = _.get(row, "name");

          return name;
        },
        rowSpan: 2,
      },
      ...dateChats.map((date) => {
        return {
          key: date,
          label: date,
          className: "text-center small",
          render: (row) => {
            const dataDate = row[date];
            const served = _.get(dataDate, "served", 0);
            const missed = _.get(dataDate, "missed", 0);
            const percentServed = maxDateChat
              ? _.round((served / maxDateChat) * 100, 0)
              : 0;
            const percentMissed = maxDateChat
              ? _.round((missed / maxDateChat) * 100, 0)
              : 0;

            return (
              <div className="d-flex">
                <div className="per-box" style={{ width: "50%" }}>
                  <span>{served}</span>
                  <div style={{ width: `${percentServed}%` }}></div>
                </div>
                <div className="per-box" style={{ width: "50%" }}>
                  <span>{missed}</span>
                  <div style={{ width: `${percentMissed}%` }}></div>
                </div>
              </div>
            );
          },
          rowSpan: 2,
        };
      }),
      {
        key: "total",
        label: t("settings.manage.report.total_serving"),
        className: "text-center small",
        render: (row) => {
          const served = _.get(row, "total.served", 0);
          const missed = _.get(row, "total.missed", 0);
          const percentServed = maxTotalChat
            ? _.round((served / maxTotalChat) * 100, 0)
            : 0;
          const percentMissed = maxTotalChat
            ? _.round((missed / maxTotalChat) * 100, 0)
            : 0;

          return (
            <div className="d-flex">
              <div className="per-box" style={{ width: "50%" }}>
                <span>{served}</span>
                <div style={{ width: `${percentServed}%` }}></div>
              </div>
              <div className="per-box" style={{ width: "50%" }}>
                <span>{missed}</span>
                <div style={{ width: `${percentMissed}%` }}></div>
              </div>
            </div>
          );
        },
        rowSpan: 2,
      },
    ],
    collection: mapChatTable,
  };

  const configRatingTable = {
    header: [
      {
        key: "agent",
        label: t("settings.manage.report.agent"),
        className: "text-center small",
        render: (row) => row.name,
        rowSpan: 2,
      },
      {
        key: "rating",
        label: t("settings.manage.report.rating"),
        colSpan: 3,
        subHeaders: [
          {
            label: t("settings.manage.report.total_rating"),
            key: "total",
            render: (row) => {
              const total = _.get(row, "total", 0);
              const unrated = _.get(row, "unrated", 0);
              return (
                <div className="d-flex align-items-center gap-2">
                  {total}{" "}
                  <span className="color-gray">
                    ({t("settings.manage.report.unrated")}: {unrated})
                  </span>
                </div>
              );
            },
          },
          {
            label: t("settings.manage.report.rated_good"),
            key: "rated_good",
            render: (row) => {
              const total = _.get(row, "total", 0);
              const good = _.get(row, "good", 0);
              const averageGood = total ? _.round((good / total) * 100, 1) : 0;

              return (
                <div className="d-flex align-items-center gap-2">
                  <i className="color-success far fa-thumbs-up"></i>
                  <span>{good}</span>
                  <span className="color-success">{averageGood}%</span>
                </div>
              );
            },
          },
          {
            label: t("settings.manage.report.rated_bad"),
            key: "rated_bad",
            render: (row) => {
              const total = _.get(row, "total", 0);
              const bad = _.get(row, "bad", 0);
              const averageBad = total ? _.round((bad / total) * 100, 1) : 0;
              return (
                <div className="d-flex align-items-center gap-2">
                  <i className="color-red far fa-thumbs-down"></i>
                  <span>{bad}</span>
                  <span className="color-red">{averageBad}%</span>
                </div>
              );
            },
          },
        ],
      },
    ],
    collection: mapRatingTable,
  };

  const configServingTable = {
    header: [
      {
        key: "agent",
        label: t("settings.manage.report.agent"),
        className: "text-center small",
        render: (row) => row.name,
      },
      ...(dates.length > 1
        ? dates.map((date) => {
            return {
              key: date,
              label: date,
              className: "text-center small",
              render: (row) => {
                const dataDate = row[date];
                const hourOnlineReports = _.get(
                  dataDate,
                  "hourOnlineReports",
                  []
                );

                return (
                  <div className="per-box per-box-2" style={{ width: "100%" }}>
                    {hourOnlineReports.map((hourOnlineReport, index) => {
                      const onlineAt = _.get(hourOnlineReport, "onlineAt");
                      const offlineAt = _.get(hourOnlineReport, "offlineAt");
                      const tooltipText = `${Moment(onlineAt).format(
                        "HH:mm"
                      )} - ${Moment(offlineAt).format("HH:mm")}`;

                      return (
                        <div
                          key={index}
                          style={{
                            left: `${hourOnlineReport.left}%`,
                            right: `${hourOnlineReport.right}%`,
                          }}
                          onMouseEnter={(e) =>
                            setTooltipConfig({
                              visible: true,
                              text: tooltipText,
                              x: e.clientX,
                              y: e.clientY,
                            })
                          }
                          onMouseLeave={() =>
                            setTooltipConfig((prev) => ({
                              ...prev,
                              visible: false,
                            }))
                          }
                        ></div>
                      );
                    })}
                  </div>
                );
              },
            };
          })
        : hourChats.map((hour) => {
            return {
              key: hour,
              label: hour,
              className: "text-center small",
              render: (row) => {
                const dataHour = row[hour];
                const minuteOnlineReports = _.get(
                  dataHour,
                  "minuteOnlineReports",
                  []
                );

                return (
                  <div className="per-box per-box-2" style={{ width: "100%" }}>
                    {minuteOnlineReports.map((minuteOnlineReport, index) => {
                      const onlineAt = _.get(minuteOnlineReport, "onlineAt");
                      const offlineAt = _.get(minuteOnlineReport, "offlineAt");
                      const tooltipText = `${Moment(onlineAt).format(
                        "HH:mm"
                      )} - ${Moment(offlineAt).format("HH:mm")}`;

                      return (
                        <div
                          key={index}
                          style={{
                            left: `${minuteOnlineReport.left}%`,
                            right: `${minuteOnlineReport.right}%`,
                          }}
                          onMouseEnter={(e) =>
                            setTooltipConfig({
                              visible: true,
                              text: tooltipText,
                              x: e.clientX,
                              y: e.clientY,
                            })
                          }
                          onMouseLeave={() =>
                            setTooltipConfig((prev) => ({
                              ...prev,
                              visible: false,
                            }))
                          }
                        ></div>
                      );
                    })}
                  </div>
                );
              },
            };
          })),
      {
        key: "total",
        label: t("settings.manage.report.total_time_serving"),
        className: "text-center small",
        render: (row) => {
          const total = _.get(row, "total", "");

          return total;
        },
      },
    ],
    collection: mapStaffTable,
    transHeader: false,
  };

  const onChangeTab = (tab) => {
    const id = _.get(tab, "id");

    if (!id) {
      return;
    }

    if (currentTab === id) {
      return;
    }

    setCurrentTab(id);
  };

  return (
    <div
      className="tab-pane fade active show"
      id="reports-tab-pane"
      role="tabpanel"
      aria-labelledby="reports-tab"
      tabIndex="0"
    >
      <div className="row mb-4 g-3">
        <div className="col-lg-3">
          <DateRangePicker
            config={{
              onChange: onChangeDateRangePicker,
              startAt,
              endAt,
            }}
          />
        </div>
        {currentTab !== "agent_online" && (
          <div className="col-lg-2">
            <Dropdown
              config={{
                options: profiles,
                map: mapConfigDomain,
                onSelect: (option) => {
                  setDomain(_.get(option, "domain", ""));
                },
                placeholder: t("settings.manage.session.domain"),
                value: domain,
              }}
            />
          </div>
        )}
        <div className="col-lg-2">
          <Autocomplete
            config={{
              options: agents,
              map: mapConfigAgent,
              onChange: (options) => {
                setStaffIds(options);
              },
              placeholder: t("settings.manage.session.agent"),
              value: staffIds,
              isMulti: true,
            }}
          />
        </div>
      </div>
      <div className="tab-box-custom">
        <Tabs
          config={{
            onChangeTab: (tab) => onChangeTab(tab),
          }}
        >
          <div
            id="report_chat"
            label="settings.manage.report.chat"
            className="btn-waiting-box show btn-chat-reports"
          >
            <C3 config={chartChatConfig} />
            <br />
            <Table config={configChatTable} />
          </div>
          <div
            id="agent_online"
            label="settings.manage.report.agent_online"
            className="btn-waiting-box show btn-agent-reports"
          >
            <Tooltip config={tooltipConfig} />
            <Table config={configServingTable} />
          </div>
          <div
            id="rating"
            label="settings.manage.report.rating"
            className="btn-waiting-box show btn-agent-reports"
          >
            <div className="mt-4">
              <div className="d-flex gap-3 align-items-center">
                <div
                  className={`btn ${
                    averageGood < 50 ? "btn-danger" : "btn-success-text"
                  }`}
                >
                  {averageGood}%
                </div>
                <span>{t("settings.manage.report.average_satisfaction")}</span>
              </div>
            </div>

            <div className="chart-box mt-4">
              <div className="row g-lg-5">
                <div className="col-lg-3 mb-4">
                  <C3 config={donutRatingConfig} />
                </div>
                <div className="col-lg-9 mb-4">
                  <C3 config={chartRatingConfig} />
                </div>
              </div>
            </div>
            <Table config={configRatingTable} />
          </div>
        </Tabs>
      </div>
    </div>
  );
};

export default ReportManage;
